var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tabbar",staticClass:"tabbar",attrs:{"slot":"tabbar"},slot:"tabbar"},_vm._l((_vm.tab),function(item,index){return _c('router-link',{key:index,staticClass:"tabbar-item",attrs:{"tag":"div","id":item.active,"to":item.link}},[_c('i',{class:item.type}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d9683e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBar.vue
// module id = null
// module chunks = 